import React from 'react';

import * as styles from './styles';
import { MetadataValue } from './types';

interface DataSectionProps {
  heading: string;
  values: MetadataValue[];
}

export function DataSection({
  heading,
  values,
}: DataSectionProps): JSX.Element {
  return (
    <styles.TableSection>
      <styles.TableHeading>{heading}</styles.TableHeading>
      {values.map((rowData: MetadataValue) => {
        if (rowData && rowData.key && rowData.value) {
          return <DataRow key={rowData.key} rowData={rowData} />;
        }
        return null;
      })}
    </styles.TableSection>
  );
}

export function DataRow({ rowData }: { rowData: MetadataValue }): JSX.Element {
  return (
    <styles.TableRow>
      <styles.TableRowKey>{rowData.key}:</styles.TableRowKey>
      <div>{`${rowData.value}`}</div>
    </styles.TableRow>
  );
}
